<template>
  <div class="vx-row">
    <div class="w-full vx-col">
        <vx-card  titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters" class="mb-8 user-list-filters" :collapse-action="true">
            <div class="vx-row">
                <div class="w-full vx-col md:w-1/3 sm:w-1/2">
                    <label class="text-sm opacity-100 text-bold">Name</label>
                    <vs-input type="search"  placeholder="Search.." v-model="filters['name']" class="w-full mb-4 md:mb-0"/>
                </div>
              <div class="w-full vx-col md:w-1/3 sm:w-1/2">
                <label class="text-sm opacity-100 text-bold">Type</label>
                <v-select :clearable="true" placeholder="" v-model="filters['type']"
                          :options="['Powder', 'Liquid', 'Spray Dry Powder', 'Fruit']" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                </v-select>
              </div>
            </div>
            <div class="mt-5 vx-row">
                <div class="w-full ml-auto vx-col">
                    <vs-button class="float-right mr-4" size="small"
                                color="danger" type="border" icon-pack="feather" v-on:click="filters={}" >CLEAR</vs-button>
                </div>
            </div>
        </vx-card>
      <vx-card :title="'CCP ITEMS'" class="">
        <template slot="actions">
          <vs-button v-can="'edit-ccp-items-setting'" @click.stop="onClickAdd" icon-pack="feather" icon="icon-plus" class="mr-4"  color="primary" type="filled">create</vs-button>
        </template>
        <div id="incoterms-table" class="vx-row">
          <div class="w-full vx-col">

            <vs-table stripe sort class="mt-8" :data="incoterms">
              <template slot="thead">
                <vs-th width="20%">Name</vs-th>
                <vs-th width="10%">Type</vs-th>
                <vs-th width="25%">Description</vs-th>
                <vs-th width="20%">Production Codes</vs-th>
                <vs-th width="10%">Available Questions</vs-th>
                <vs-th width="15%">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr class="cursor-pointer" :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].name">
                    {{ data[indextr].name }}
                  </vs-td>

                  <vs-td :data="data[indextr].type">
                    {{ data[indextr].type }}
                  </vs-td>

                  <vs-td :data="data[indextr].description">
                    <vx-read-more :length="100" :text="data[indextr].description"/>
                  </vs-td>

                  <vs-td :data="data[indextr].production_codes" style="white-space: normal; word-break: break-word;">
                    <template v-if="Array.isArray(data[indextr].production_codes) && data[indextr].production_codes.length">
                      <span v-for="(code, idx) in data[indextr].production_codes" :key="code.id">
                        <HyperLink :id="code.id" type="production-code">{{ code.prefix }}</HyperLink><span v-if="idx < data[indextr].production_codes.length - 1">, </span>
                      </span>
                    </template>
                  </vs-td>

                  <vs-td>
                    {{ data[indextr].fields.length }}
                  </vs-td>

                  <vs-td :data="data[indextr].name">
                    <div class="justify-start vx-row" v-can="'edit-ccp-items-setting'">
                      <vx-tooltip text="View/Update" position="left">
                        <vs-button @click.stop="onClickUpdate(data[indextr].id)"  class="ml-3"
                                   size="small" color="warning" type="border" icon-pack="feather" icon="icon-edit-2"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip text="Manage Questions" position="left">
                        <vs-button @click.stop="onClickManageFields(data[indextr].id)"  class="ml-3"
                                   size="small" color="success" type="border" icon-pack="feather" icon="icon-settings"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip text="Remove" position="left">
                        <vs-button @click.stop="openConfirm(data[indextr].id)" class="ml-3"
                                   size="small" color="danger" type="border" icon-pack="feather" icon="icon-trash-2"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>

                </vs-tr>
              </template>

            </vs-table>
            <vs-pagination
              v-on:changeMaxItems="changePage"
              :size-array="meta.total ? meta.total : 20"
              :max-items="perPage"
              description-body="Rows per page"
              description-connector="of"
              description-title="Records"
              description
              :description-items="descriptionItems"
              :total="(meta.last_page)? meta.last_page : 0"
              v-model="page"  class="p-5">
            </vs-pagination>


          </div>
        </div>
      </vx-card>
    </div>
    <add-new-incoterms-pop-up ref="AddNewIncotermsPopUp"/>
    <add-new-ccp-item-pop-up ref="addNewCcpItemPopUp"/>
    <ManageCcpItemFieldsPopUp ref="ManageCcpItemFieldsPopUp"/>
  </div>
</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory';
  import AddNewIncotermsPopUp from "@/components/popups/settings/incoterms/AddNewIncotermsPopUp";
  import AddNewCcpItemPopUp from "@/components/popups/settings/ccp-items/AddNewCcpItemPopUp";
  import ManageCcpItemFieldsPopUp from "@/components/popups/settings/ccp-items/ManageCcpItemFieldsPopUp";
  import vSelect from 'vue-select'

  import Filter from '@/mixins/filter';
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  import {defaultPagination, perPageList} from "@/constants/config";

  const IncotermRepository = RepositoryFactory.get('incoterm');
  const CcpRepository = RepositoryFactory.get('ccp');

  export default {
    name: "CcpItemSettings",
    data() {
      return {
        incoterms: [],
        filters: {},
        page : 1,
        total: 0,
        meta : {},
        sort : '',
        perPage: defaultPagination,
        descriptionItems: perPageList,
      }
    },
    components: {
      AddNewIncotermsPopUp,
      AddNewCcpItemPopUp,
      'v-select': vSelect,
      ManageCcpItemFieldsPopUp
    },
    methods: {
      async refreshData() {
        await this.fetchIncoterms()
      },
      async fetchIncoterms() {
        await this.$vs.loading({
          container: '#incoterms-table',
          scale: 0.45
        })
        const {data} = await CcpRepository.getListOfCcp(this.page, this.filterQuery, this.perPage, this.sort)
        this.incoterms =  data.data
         this.meta = data.meta
        this.$vs.loading.close('#incoterms-table > .con-vs-loading')
      },
      async onClickAdd() {
        await this.$refs.addNewCcpItemPopUp.openPopup()
      },
      async onClickUpdate(id) {
        await this.$refs.addNewCcpItemPopUp.openPopup(id)
      },
      async onClickManageFields(id) {
        await this.$refs.ManageCcpItemFieldsPopUp.openPopup(id)
      },
      openConfirm(id) {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: `Confirm`,
          text: 'Are you sure you want to delete this ?',
          accept: this.onClickDelete,
          parameters: [id]
        })
      },
      async onClickDelete(params) {
        try {
          await CcpRepository.deleteCcp(params[0])
          await this.fetchIncoterms()
          await this.showSuccessMessage('Incoterm Deleted!');
        }catch (e) {
            this.convertAndNotifyError(e)
        }
      },
      filterQueryUpdate (){
        this.fetchIncoterms()
      },

      handleChangePage(page) {
        this.page=page;
        this.fetchIncoterms()
      },
      handleSort(key, active) {
        if(key){
          active = (active==='desc')? "-":'';
          this.sort=active+key;
          this.fetchIncoterms()
        }
      },
      changePage(index) {
        this.perPage = this.descriptionItems[index]
      },
    },
    async mounted() {
      await this.fetchIncoterms()
    },
    mixins: [Filter, SuccessMessage, ErrorMessages],
     watch : {
      page(){
        this.fetchIncoterms()
      },
      perPage() {
        this.fetchIncoterms()
      }
    }
  }
</script>

<style scoped>

</style>
